module.exports = __webpack_public_path__ + "img/person_outline.14cfb23b.svg";